import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { users } from "@/api/api";
import { isInstallerOnly } from "@/user/user";

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer'
)({
  beforeLoad: async ({ context, params: { organizationId } }) => {
    const user = await context.queryClient.ensureQueryData(users.me());

    // Redirect installer-only users to install page
    if (user && isInstallerOnly(user, organizationId)) {
      throw redirect({
        to: '/organization/$organizationId/install',
        params: { organizationId }
      });
    }
  },
  component: () => <Outlet />
})
